(function () {
  'use strict';

  const clamp = (value, min, max) => {
    return Math.min(Math.max(value, min), max);
  };

  function initEpelayHero(hero) {
    if (!hero) return;
    if (hero.dataset.epelayInitialized === 'true') return;

    hero.dataset.epelayInitialized = 'true';

    const scene = hero.querySelector('.epelay-hero__scene');
    const background = hero.querySelector('.epelay-hero__background');
    const content = hero.querySelector('.epelay-hero__content');
    const starsContainer = hero.querySelector('.epelay-hero__stars');
    const meteorsContainer = hero.querySelector('.epelay-hero__meteors');

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const finePointer = window.matchMedia('(pointer: fine)').matches;

    let isVisible = false;
    let meteorTimer = null;

    /* =========================================================
       STARS
       ========================================================= */

    function createStars() {
      if (!starsContainer) return;

      starsContainer.innerHTML = '';

      const mobile = window.innerWidth < 750;
      const tablet = window.innerWidth >= 750 && window.innerWidth < 990;

      let count = 68;
      if (tablet) count = 50;
      if (mobile) count = 32;

      for (let i = 0; i < count; i++) {
        const star = document.createElement('span');
        star.className = 'epelay-hero__star';

        if (Math.random() > 0.84) {
          star.classList.add('is-bright');
        }

        const size = 0.7 + Math.random() * 1.7;
        const x = Math.random() * 100;
        const y = 1 + Math.random() * 55;
        const speed = 3.2 + Math.random() * 5.4;
        const delay = Math.random() * 6;

        star.style.left = `${x}%`;
        star.style.top = `${y}%`;
        star.style.setProperty('--star-size', `${size}px`);
        star.style.setProperty('--star-speed', `${speed}s`);
        star.style.setProperty('--star-delay', `-${delay}s`);

        starsContainer.appendChild(star);
      }
    }

    /* =========================================================
       METEOR
       ========================================================= */

    function spawnMeteor(forceLarge = false) {
      if (!meteorsContainer) return;
      if (!isVisible) return;
      if (document.visibilityState !== 'visible') return;

      const meteor = document.createElement('span');
      meteor.className = 'epelay-hero__meteor';

      const large = forceLarge || Math.random() > 0.78;
      if (large) {
        meteor.classList.add('is-big');
      }

      const top = 4 + Math.random() * 27;
      const left = 70 + Math.random() * 25;
      const width = large ? 150 + Math.random() * 70 : 95 + Math.random() * 70;
      const duration = large ? 1.08 + Math.random() * 0.28 : 0.88 + Math.random() * 0.25;
      const angle = -18 - Math.random() * 12;
      const travelX = -300 - Math.random() * 200;
      const travelY = 90 + Math.random() * 95;

      meteor.style.top = `${top}%`;
      meteor.style.left = `${left}%`;
      meteor.style.width = `${width}px`;
      meteor.style.setProperty('--meteor-angle', `${angle}deg`);
      meteor.style.setProperty('--meteor-speed', `${duration}s`);
      meteor.style.setProperty('--meteor-x', `${travelX}px`);
      meteor.style.setProperty('--meteor-y', `${travelY}px`);

      meteorsContainer.appendChild(meteor);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          meteor.classList.add('is-active');
        });
      });

      window.setTimeout(() => {
        meteor.remove();
      }, duration * 1000 + 250);
    }

    function scheduleMeteor() {
      if (reducedMotion) return;

      if (meteorTimer) {
        clearTimeout(meteorTimer);
      }

      const mobile = window.innerWidth < 750;

      /* 更多一点流星 */
      const nextDelay = mobile
        ? 6500 + Math.random() * 5000
        : 4200 + Math.random() * 3600;

      meteorTimer = window.setTimeout(() => {
        if (isVisible) {
          spawnMeteor(false);

          /* 提高双流星概率，但不要太夸张 */
          if ((!mobile && Math.random() > 0.62) || (mobile && Math.random() > 0.82)) {
            window.setTimeout(() => {
              spawnMeteor(false);
            }, 500 + Math.random() * 700);
          }
        }

        scheduleMeteor();
      }, nextDelay);
    }

    /* =========================================================
       3D SCENE + PRODUCT LIGHT
       ========================================================= */

    function initSceneInteraction() {
      if (!finePointer) return;
      if (reducedMotion) return;
      if (!scene) return;

      let targetRotX = 0;
      let targetRotY = 0;
      let currentRotX = 0;
      let currentRotY = 0;

      let targetSceneScale = 1;
      let currentSceneScale = 1;

      let targetFilamentScale = 1;
      let currentFilamentScale = 1;

      let targetModelScale = 1;
      let currentModelScale = 1;

      let targetLightX = 79;
      let targetLightY = 48;
      let currentLightX = 79;
      let currentLightY = 48;

      let targetLightOpacity = 0;
      let currentLightOpacity = 0;

      let targetLightRotation = -11;
      let currentLightRotation = -11;

      let targetSat = 1;
      let currentSat = 1;

      let targetBright = 1;
      let currentBright = 1;

      let raf = null;

      function updateInteraction() {
        currentRotX += (targetRotX - currentRotX) * 0.065;
        currentRotY += (targetRotY - currentRotY) * 0.065;

        currentSceneScale += (targetSceneScale - currentSceneScale) * 0.06;

        currentFilamentScale += (targetFilamentScale - currentFilamentScale) * 0.07;
        currentModelScale += (targetModelScale - currentModelScale) * 0.07;

        currentLightX += (targetLightX - currentLightX) * 0.065;
        currentLightY += (targetLightY - currentLightY) * 0.065;
        currentLightOpacity += (targetLightOpacity - currentLightOpacity) * 0.075;
        currentLightRotation += (targetLightRotation - currentLightRotation) * 0.07;

        currentSat += (targetSat - currentSat) * 0.08;
        currentBright += (targetBright - currentBright) * 0.08;

        hero.style.setProperty('--ep-scene-rotate-x', `${currentRotX.toFixed(3)}deg`);
        hero.style.setProperty('--ep-scene-rotate-y', `${currentRotY.toFixed(3)}deg`);
        hero.style.setProperty('--ep-scene-scale', currentSceneScale.toFixed(4));

        hero.style.setProperty('--ep-filament-hover-scale', currentFilamentScale.toFixed(4));
        hero.style.setProperty('--ep-model-hover-scale', currentModelScale.toFixed(4));

        hero.style.setProperty('--ep-light-x', `${currentLightX.toFixed(2)}%`);
        hero.style.setProperty('--ep-light-y', `${currentLightY.toFixed(2)}%`);
        hero.style.setProperty('--ep-light-opacity', currentLightOpacity.toFixed(3));
        hero.style.setProperty('--ep-light-rotation', `${currentLightRotation.toFixed(3)}deg`);

        hero.style.setProperty('--ep-product-sat', currentSat.toFixed(3));
        hero.style.setProperty('--ep-product-bright', currentBright.toFixed(3));

        const moving =
          Math.abs(targetRotX - currentRotX) > 0.01 ||
          Math.abs(targetRotY - currentRotY) > 0.01 ||
          Math.abs(targetSceneScale - currentSceneScale) > 0.001 ||
          Math.abs(targetFilamentScale - currentFilamentScale) > 0.001 ||
          Math.abs(targetModelScale - currentModelScale) > 0.001 ||
          Math.abs(targetLightX - currentLightX) > 0.02 ||
          Math.abs(targetLightY - currentLightY) > 0.02 ||
          Math.abs(targetLightOpacity - currentLightOpacity) > 0.01 ||
          Math.abs(targetLightRotation - currentLightRotation) > 0.01 ||
          Math.abs(targetSat - currentSat) > 0.01 ||
          Math.abs(targetBright - currentBright) > 0.01;

        if (moving) {
          raf = requestAnimationFrame(updateInteraction);
        } else {
          raf = null;
        }
      }

      function requestUpdate() {
        if (!raf) {
          raf = requestAnimationFrame(updateInteraction);
        }
      }

      hero.addEventListener(
        'pointermove',
        (event) => {
          const rect = hero.getBoundingClientRect();

          const rawX = ((event.clientX - rect.left) / rect.width) * 100;
          const rawY = ((event.clientY - rect.top) / rect.height) * 100;

          /* 整体场景 3D 转动 */
          targetRotY = clamp((rawX - 50) * 0.09, -4.5, 4.5);
          targetRotX = clamp((50 - rawY) * 0.065, -3.2, 3.2);

          /* 整体轻微推进 */
          targetSceneScale = 1.012;

          /* 产品区域进一步放大 */
          if (rawX >= 56) {
            targetFilamentScale = 1.085;
            targetModelScale = 1.04;
            targetLightOpacity = 0.98;
            targetSat = 1.26;
            targetBright = 1.065;
          } else if (rawX >= 46) {
            targetFilamentScale = 1.045;
            targetModelScale = 1.02;
            targetLightOpacity = 0.72;
            targetSat = 1.13;
            targetBright = 1.03;
          } else if (rawX >= 38) {
            targetFilamentScale = 1.015;
            targetModelScale = 1.008;
            targetLightOpacity = 0.26;
            targetSat = 1.04;
            targetBright = 1.01;
          } else {
            targetFilamentScale = 1.005;
            targetModelScale = 1.003;
            targetLightOpacity = 0.08;
            targetSat = 1.01;
            targetBright = 1.005;
          }

          /* 灯光只在右侧产品区活动 */
          targetLightX = clamp(rawX, 48, 97);
          targetLightY = clamp(rawY, 18, 82);

          /* 灯光角度略变化，更像横向扫光 */
          targetLightRotation = clamp(-9 + (rawX - 74) * 0.055, -12.5, -6.5);

          requestUpdate();
        },
        { passive: true }
      );

      hero.addEventListener(
        'pointerenter',
        () => {
          targetSceneScale = 1.006;
          targetLightOpacity = 0.12;
          requestUpdate();
        },
        { passive: true }
      );

      hero.addEventListener(
        'pointerleave',
        () => {
          targetRotX = 0;
          targetRotY = 0;
          targetSceneScale = 1;

          targetFilamentScale = 1;
          targetModelScale = 1;

          targetLightX = 79;
          targetLightY = 48;
          targetLightOpacity = 0;
          targetLightRotation = -11;

          targetSat = 1;
          targetBright = 1;

          requestUpdate();
        },
        { passive: true }
      );
    }

    /* =========================================================
       BACKGROUND SCROLL
       ========================================================= */

    function initScrollMotion() {
      if (reducedMotion) return;
      if (!background) return;

      let ticking = false;

      function update() {
        const rect = hero.getBoundingClientRect();
        const progress = clamp(-rect.top / rect.height, 0, 1);

        const bgY = progress * -22;
        const bgScale = 1.045 + progress * 0.052;

        background.style.setProperty('--ep-bg-y', `${bgY}px`);
        background.style.setProperty('--ep-bg-scale', bgScale.toFixed(4));

        if (content) {
          const opacity = 1 - clamp(progress * 1.55, 0, 0.90);
          const moveY = progress * -24;
          content.style.opacity = opacity;
          content.style.transform = `translate3d(0, ${moveY}px, 0)`;
        }

        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }

      update();

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    /* =========================================================
       OBSERVER
       ========================================================= */

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isVisible = entry.isIntersecting;

          if (isVisible) {
            hero.classList.add('is-visible');

            if (!hero.dataset.firstMeteor && !reducedMotion) {
              hero.dataset.firstMeteor = 'true';

              window.setTimeout(() => {
                if (isVisible) {
                  spawnMeteor(true);
                }
              }, 1400);
            }
          }
        });
      },
      { threshold: 0.12 }
    );

    observer.observe(hero);

    /* =========================================================
       INIT
       ========================================================= */

    createStars();

    if (!reducedMotion) {
      initSceneInteraction();
      initScrollMotion();
      scheduleMeteor();
    } else {
      hero.classList.add('is-visible');
    }
  }

  function initAllEpelayHeroes() {
    document.querySelectorAll('[data-epelay-hero]').forEach((hero) => {
      initEpelayHero(hero);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllEpelayHeroes);
  } else {
    initAllEpelayHeroes();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const hero = event.target.querySelector('[data-epelay-hero]');
    if (hero) {
      initEpelayHero(hero);
    }
  });
})();